import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SuccessPage from "Sections/booking/accepted-step";
import { getRelativePath } from "base/shared/Utils";

const PurchaseSuccess = () => {
  return <SuccessPage url={getRelativePath("/inbox")} />;
};

export default PurchaseSuccess;
